import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=55500912&scoped=true&"
import script from "./credit.js?vue&type=script&lang=js&"
export * from "./credit.js?vue&type=script&lang=js&"
import style0 from "./credit.scss?vue&type=style&index=0&id=55500912&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55500912",
  null
  
)

export default component.exports